import { z } from 'zod';
import { SCAN_HOURS, SCAN_SHAPES } from '../filters/registry.js';

/**
 * The Scan approvals queue's query. Its own file because attendance.schema.ts
 * is at its line budget.
 *
 * `q` and `reasons` search the WHOLE queue on the server (audit 2026-10-27;
 * packages/api/src/services/flaggedScans.search.ts): the page used to filter
 * only the hundred scans it had loaded. `reasons` is the comma-joined reason
 * CODES whose translated label matches `q` — the page knows its labels, the
 * server does not.
 *
 * `worksiteId`, `shape` and `hours` are the registry's `site`, `shape` and
 * `hours` filters (packages/shared/src/filters/registry.ts), narrowed on the
 * server over the whole queue for the same reason — they were applied in the
 * browser to the page it held (services/flaggedScanFilters.ts).
 */
export const FlaggedScanQuerySchema = z.object({
  worksiteId: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
  q: z.string().trim().max(80).optional(),
  reasons: z.string().max(1000).optional(),
  shape: z.enum(SCAN_SHAPES).optional(),
  hours: z.enum(SCAN_HOURS).optional(),
  /** The whole held set under these filters as a file (merge E6) — not the 100-per-page. */
  format: z.enum(['excel', 'csv']).optional(),
});
export type FlaggedScanQuery = z.infer<typeof FlaggedScanQuerySchema>;
